import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { MainNavbarComponent } from './core/components/main-navbar/main-navbar.component';
import { ChatWidgetComponent } from './features/chat-widget/chat-widget.component';
import { AuthService } from './core/services/auth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule, MainNavbarComponent, ChatWidgetComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'frontend';
  showChatWidget = false;
  private authSub?: Subscription;

  constructor(private authService: AuthService) {}

  ngOnInit() {
    this.authService.checkLogin();
    this.authSub = this.authService.authenticated.subscribe((auth) => {
      // Alpha-only for now — remove role check to enable for all users
      const roles = localStorage.getItem('roles') || '';
      this.showChatWidget = auth && roles.includes('alpha');
    });
  }

  ngOnDestroy() {
    this.authSub?.unsubscribe();
  }
}
